import { IAccount } from 'models/account';
import { Business } from 'models/business';

export const isOwner = (
  business: Business,
  accounts: IAccount[],
  userId?: string,
) => {
  if (!userId) {
    return false;
  }
  const account = accounts.find((a) => business.accountId === a.id);
  return account?.ownerUserId === userId;
};
